module.exports = __webpack_public_path__ + "static/media/yoke.d0cc5b44.webp";